<template>
    <div class="container-fluid">
        <div class="container is-fluid">

            <div class="columns">
                <div class="column has-text-centered" v-if="isAdmin && $route.path != '/balance-statement/'"></div>
                <div class="column has-text-centered">
                    <h1 class="title">Transaction</h1>
                </div>

                <div class="column" v-if="isAdmin && $route.path != '/balance-statement/'">
                    <div class="dropdown is-hoverable mb-15 is-pulled-right">
                        <div class="dropdown-trigger">
                            <button class="button is-success" aria-haspopup="true" aria-controls="dropdown-menu" @click="">
                                <span>Add Transaction</span>
                                <span class="icon is-small">
                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                            </button>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <router-link
                                        tag="a"
                                        :to="'/balance-statement/create/'+currentUserId"
                                        class="dropdown-item">
                                    <span>Money In</span>
                                </router-link>
                                <router-link
                                        tag="a"
                                        :to="'/balance-statement/create-refund/'+currentUserId"
                                        class="dropdown-item">
                                    <span>Money Out</span>
                                </router-link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="theme-table-container table-container center-column w-100">
                        <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                            <thead>
                            <tr>
                                <th class="invoice_id"><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                <th class="issued_date"><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                <th class="chassis"><span @click="setOrder('manager_id')" class="link">Chassis</span></th>
                                <th class="invoice_amount"><span @click="setOrder('manager_id')" class="link">Invoice Amount</span></th>
                                <th class="paid_amount"><span @click="setOrder('manager_id')" class="link">Paid Amount</span></th>
                                <th class="due_amount"><span @click="setOrder('manager_id')" class="link">Balance Due</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="invoice in getUnpaidInvoices">
                                <td class="invoice_id">#{{ invoice.id }}</td>
                                <td class="issued_date">{{ invoice.issued_date }}</td>
                                <td class="chassis">{{ invoice.car.model_type_en }}</td>
                                <td class="invoice_amount">{{ getCurrency }}{{ invoice.sub_total | formatNumber }}</td>
                                <td class="paid_amount has-text-success" v-if="invoice.paid_amount > 0">
                                    {{ getCurrency }}{{ invoice.paid_amount | formatNumber }}
                                    <span
                                            class="icon link"
                                            @click="openPaidAmount(invoice.id, invoice.car.model_type_en)"
                                    >
                      <i class="fas fa-eye"></i>
                    </span>
                                </td>
                                <td v-else>---</td>
                                <td class="due_amount has-text-danger">{{ getCurrency }}{{ (invoice.balance_due - invoice.paid_amount) | formatNumber}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <paid-amount-modal v-bind:inv="inv" v-bind:cha="cha" v-bind:paidAmounts="paidAmounts"></paid-amount-modal>
                </div>
            </div>

            <div class="columns" v-if="getUnpaidInvoices.length > 0">
                <div class="column has-text-centered">
                    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentPage > 2"
                                        @click="changePage(getFirstPage)"
                                >{{ getFirstPage }}</a>
                            </li>
                            <li>
                                <span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentPage > 1"
                                        @click="changePage(getCurrentPage - 1)"
                                >{{ getCurrentPage - 1 }}</a>
                            </li>
                            <li>
                                <a
                                        class="pagination-link is-current"
                                        @click="changePage(getCurrentPage)"
                                >{{ getCurrentPage }}</a>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentPage < getLastPage"
                                        @click="changePage(getCurrentPage + 1)"
                                >{{ getCurrentPage + 1 }}</a>
                            </li>
                            <li>
                                <span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        @click="changePage(getLastPage)"
                                        v-if="getCurrentPage + 1 < getLastPage"
                                >{{ getLastPage }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div class="columns">
                <div class="column">

                    <div class="transaction-row field-row">
                        <div class="field transaction-field">
                            <p class="control search-field is-expanded has-icons-left is-fullwidth">
                                <input class="input" type="text" v-model="search" v-on:keyup="searchFormChange"
                                       placeholder="Search Transactions">
                                <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_from"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date from"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_to"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date to"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            <app-loader :loading="false" :color="options.color" :size="options.size"></app-loader>
            <div class="desktop-table columns" v-if="transactionTotals">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <tr>
                            <th class="cursor-pointer" @click="openClientDeposit">Client Deposit</th>
                            <td class="cursor-pointer" @click="openClientDeposit">{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                            <th>Amount received</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_received | formatNumber }}</td>
                            <th>Amount used for payments</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_used | formatNumber }}</td>
                            <th class="cursor-pointer" @click="openReceivables">Receivables</th>
                            <td class="cursor-pointer" @click="openReceivables">{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="mobile-table columns" v-if="transactionTotals">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <tr>
                            <th class="cursor-pointer" @click="openClientDeposit">Client Deposit</th>
                            <td class="cursor-pointer" @click="openClientDeposit">{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Amount received</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_received | formatNumber }}</td>
                        </tr>
                        <tr>
                            <th>Amount used for payments</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_used | formatNumber }}</td>
                        </tr>
                        <tr>
                            <th class="cursor-pointer" @click="openReceivables">Receivables</th>
                            <td class="cursor-pointer" @click="openReceivables">{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="columns center" v-if="!getLoaderStatus">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <thead>
                        <tr>
                            <th><span @click="setOrder('id')" class="link">ID</span></th>
                            <th><span @click="setOrder('transaction_date')" class="link">Date</span></th>
                            <th><span @click="setOrder('type')" class="link">Type</span></th>
                            <th><span @click="setOrder('amount')" class="link">Amount</span></th>
                            <th><span @click="setOrder('payment')" class="link">Payment</span></th>
                            <th style="min-width:200px"><span @click="setOrder('amount_excess')" class="link">Amount in excess</span></th>
                            <th><span @click="setOrder('deposit')" class="link">Deposit</span></th>
                            <th v-if="isAdmin && $route.path != '/balance-statement/'">Action</th>
                        </tr>
                        </thead>
                        <transaction-client-table-row :transactionTotals="transactionTotals"></transaction-client-table-row>
                    </table>
                </div>
            </div>
            <div class="columns" v-if="hasTransactions">
                <div class="column has-text-centered">
                    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentTransactionPage > 2"
                                        @click="changeTransactionPage(getFirstTransactionPage)"
                                >{{ getFirstTransactionPage }}</a>
                            </li>
                            <li>
                                <span class="pagination-ellipsis" v-if="getCurrentTransactionPage > 2">&hellip;</span>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentTransactionPage > 1"
                                        @click="changeTransactionPage(getCurrentTransactionPage - 1)"
                                >{{ getCurrentTransactionPage - 1 }}</a>
                            </li>
                            <li>
                                <a
                                        class="pagination-link is-current"
                                        @click="changeTransactionPage(getCurrentTransactionPage)"
                                >{{ getCurrentTransactionPage }}</a>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        v-if="getCurrentTransactionPage < getLastTransactionPage"
                                        @click="changeTransactionPage(getCurrentTransactionPage + 1)"
                                >{{ getCurrentTransactionPage + 1 }}</a>
                            </li>
                            <li>
                <span
                        class="pagination-ellipsis"
                        v-if="getCurrentTransactionPage + 1 < getLastTransactionPage"
                >&hellip;</span>
                            </li>
                            <li>
                                <a
                                        class="pagination-link"
                                        @click="changeTransactionPage(getLastTransactionPage)"
                                        v-if="getCurrentTransactionPage + 1 < getLastTransactionPage"
                                >{{ getLastTransactionPage }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <client-deposit-history-modal></client-deposit-history-modal>
            <receivalbes-modal></receivalbes-modal>
        </div>
    </div>
</template>

<script>
    import appLoader from "vue-spinner/src/ClipLoader";
    import { Datetime } from "vue-datetime";
    import "vue-datetime/dist/vue-datetime.css";
    import { ModelSelect } from "vue-search-select";
    import TransactionClientTableRow from "./TransactionClientTableRow";
    import ClientDepositHistoryModal from "../Banking/ClientDepositHistoryModal";
    import ReceivalbesModal from "../Banking/ReceivalbesModal";
    import PaidAmountModal from "../Banking/PaidAmountModal";
    import apiBankingTransactions from "./../../api/apiBankingTransactions";

    export default {
        props: ["user"],
        components: {
            ReceivalbesModal,
            PaidAmountModal,
            ClientDepositHistoryModal,
            TransactionClientTableRow,
            appLoader,
            Datetime,
            ModelSelect,
        },
        data() {
            return {
                options: [],
                addTransactionModal: false,
                search: "",
                client: this.$route.params.id !== undefined ? this.$route.params.id : "",
                dateFrom: "",
                dateTo: "",
                order: 1,
                clientId: this.client,
                unpaidInvoices: [],
                currentPage: 1,
                lastPage: 1,
                inv: "",
                cha: "",
                paidAmounts: [],
            };
        },
        computed: {
            getUnpaidInvoices() {
                return this.unpaidInvoices;
            },
            currentUserId() {
                return this.$route.params.id !== undefined
                    ? this.$route.params.id
                    : this.$store.getters.getCurrentUser.user.id;
            },
            getCurrency() {
                return this.$store.getters.getCurrentUser.info.price_plan.deposit_rate ==
                1
                    ? "¥"
                    : "$";
            },
            hasTransactions() {
                return this.$store.getters.getAllTransactions.length > 0 ? true : false;
            },
            getCurrentPage() {
                return this.currentPage;
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus;
            },
            transaction_from: {
                get() {
                    return this.dateFrom;
                },
                set(value) {
                    this.dateFrom = value;
                    this.filter();
                },
            },
            transaction_to: {
                get() {
                    return this.dateTo;
                },
                set(value) {
                    this.dateTo = value;
                    this.filter();
                },
            },
            transactionTotals() {
                return this.$store.getters.getClientTransactionTotals;
            },
            getFirstPage() {
                return 1;
            },
            getLastPage() {
                return this.lastPage;
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === "Admin") {
                    return true;
                }
            },
            currentRouteName() {
                return this.$route.name;
            },
            getCurrentTransactionPage() {
                return parseInt(this.$store.getters.getTransactionCurrentPage);
            },

            getFirstTransactionPage() {
                return this.$store.getters.getTransactionFirstPage;
            },
            getLastTransactionPage() {
                return this.$store.getters.getTransactionLastPage;
            },
        },
        methods: {
            setOrder(orderBy) {
                this.order = this.order == "1" ? 0 : 1;
                this.$store.commit("setOrderByTransactions", {
                    orderBy: orderBy,
                    order: this.order,
                });
                this.$store.dispatch("getTransactionsAction");
            },
            filter() {
                const user_id = this.client ? this.client : this.currentUserId;
                this.$store.commit("setFilterTransactions", {
                    client: user_id,
                    search: this.search,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                });
                this.$store.dispatch("getTransactionsAction");
            },
            searchFormChange() {
                this.filter();
            },
            addTransaction() {
                this.addTransactionModal = true;
            },
            changePage(page) {
                const data = { page: page, user_id: this.currentUserId };
                apiBankingTransactions.getClientUnpaidInvoices(data).then((response) => {
                    if (response.data) {
                        this.lastPage = response.data.last_page;
                        this.currentPage = response.data.current_page;
                        this.unpaidInvoices = response.data.data;
                    }
                });
                //this.$router.push({ path: "/banking", query: { page: page } });
            },
            openClientDeposit() {
                const user_id = this.client ? this.client : this.currentUserId;
                this.$store.commit("setClientDepositModalStatus", true);
                this.$store.dispatch("fetchClientDeposits", user_id);
            },
            openReceivables() {
                const user_id = this.client ? this.client : this.currentUserId;
                this.$store.commit("setReceivablesModalStatus", true);
                this.$store.dispatch('fetchReceivables', user_id)
            },
            openPaidAmount(inv, cha) {
                this.inv = inv;
                this.cha = cha;
                this.$store.commit("setPaidAmountModalStatus", true);
                apiBankingTransactions.fetchPaidAmounts(inv).then((res) => {
                    this.paidAmounts = res.data.payments;
                    console.log(this.paidAmounts);
                });
            },
            changeTransactionPage(page) {
                this.$router.push({ path: "/banking", query: { page: page } });
            },
        },
        created() {
            const user_id = this.client ? this.client : this.currentUserId;
            this.$store.commit("setClientTransactionTotals", "");
            this.$store.dispatch("getClientTransactionTotals", "");
            this.$store.commit("setQueryClient", user_id);
            const data = { page: 1, user_id: user_id };
            apiBankingTransactions.getClientUnpaidInvoices(data).then((response) => {
                if (response.data) {
                    this.lastPage = response.data.last_page;
                    this.currentPage = response.data.current_page;
                    this.unpaidInvoices = response.data.data;
                }
            });
        },
        watch: {
            inv(o, n) {
                this.inv = n;
            },
            $route(to, from) {
                const user_id = this.client ? this.client : this.currentUserId;
                this.$store.commit("setTransactionCurrentPage", to.query.page);
                this.$store.commit("setQueryClient", user_id);
                this.$store.dispatch("getTransactionsAction");
            },
        },
    };
</script>
<style scoped>
    .container {
        margin-top: 25px;
    }

    .field-row {
        display: flex;
    }

    .field-row .field {
        margin-right: 10px;
    }

    .field.transaction-field,
    .field.client-field {
        flex: 1 1 33%;
    }

    .field.transaction-field {
        flex: 1 1 33%;
    }

    .ui.selection.dropdown {
        min-height: unset;
        padding-top: 9px;
    }
    span.link {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Balance-Statement/TransactionsClientTable.vue